import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto; // Enable vertical scrolling
  overflow-x: hidden; // Prevent horizontal scrolling
  padding: 10px; // Add consistent padding
`;

export const Divider = styled.hr`
  margin: -10px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;
  color: #f2f2f3;
`;

export const InfoBox = styled.div`
  height: 50px;
  width: 97%;
  margin-left: 1.5%;
  border: 1px solid #d4d4d4;
  background-color: #f5f5f5;
  border-radius: 5px;
  margin-bottom: 3px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5px;
  height: 100%;
  gap: 10px;
`;

export const Title = styled.span`
  font-family: Inter, sans-serif;
  font-size: 13px;
  line-height: 22px;
  color: #137f95;
  font-weight: 600;
`;

export const Tag = styled.div`
  background-color: #e7f2f4;
  border-radius: 20px;
  padding: 5px 15px;
  font-size: 12px;
  font-family: Inter, sans-serif;
  color: #000;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 5px;
  margin-left: 16px;
  margin-top: 10px;
`;

export const Tab = styled.div<{ active?: boolean }>`
  padding: 8px 16px;
  border: 1px solid #e5e5e5;
  border-bottom: ${({ active }) => (active ? 'none' : '1px solid #e5e5e5')};
  background-color: ${({ active }) => (active ? '#fff' : '#f8f8f8')};
  color: ${({ active }) => (active ? '#007c91' : '#777')};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  font-size: 14px;
`;

export const UploadSection = styled.div`
  padding: 16px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  width: 97%;
  margin-left: 1.5%;
  max-height: 550px; /* limit height */
  min-height: 550px; /* limit height */
  overflow-y: auto; /* enable scrolling */
`;

export const AssetLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #000;
`;

export const SubText = styled.div`
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  margin-top: 5px;
`;

export const UploadBox = styled.div`
  border: 2px dashed #ccc;
  border-radius: 6px;
  height: auto;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #007c91;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease-in-out;
  background-color: #fafafa;
  padding: 10px;

  &:hover {
    border-color: #007c91;
    background-color: #f9fefe;
  }
`;

export const UploadPlus = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
`;

export const PrimaryText = styled.div`
  font-size: 14px;
  color: #777;
  font-weight: 500;

  /* make * red when included in text */
  &::after {
    content: '';
  }

  span.required {
    color: #d11a2a; /* red */
    margin-left: 2px;
  }
`;

export const FileName = styled.div`
  color: #333;
  font-weight: 500;
  font-size: 14px;
`;

export const FilePreview = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const FileHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #137f95;
  font-size: 18px;
  cursor: pointer;
  font-weight: bold;
  transition: color 0.2s;

  &:hover {
    color: #d11a2a;
  }
`;

export const ImagePreview = styled.img`
  max-width: 250px;
  max-height: 80px;
  border-radius: 4px;
  object-fit: contain;
  background-color: #eaf5ec;
  padding: 4px;
`;

export const DimensionText = styled.div`
  font-size: 13px;
  color: #007c91;
  font-weight: 500;
`;
export const FormSection = styled.div`
  margin-top: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
`;

export const Input = styled.input`
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
  &:focus {
    border-color: #157f95;
    outline: none;
  }
`;

export const DisabledInput = styled.input`
  background-color: #f5f5f5;
  cursor: not-allowed;
  font-size: 14;
  width: 255;
`;

export const Select = styled.select`
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
  background-color: #fff;
  &:focus {
    border-color: #157f95;
    outline: none;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;
